import Vue from 'vue/dist/vue.js'
import { computePosition, shift, flip } from '@floating-ui/dom'


export default Vue.extend({
  template: `
  <div class="custom-tooltip all_tags_holder_block" v-bind:style="{ backgroundColor: color, visibility: 'hidden' }" ref="CustomTooltip">
  <div class="custom-tooltip-inner">
    <p style="width: 100%;" v-if="allTag.length != 0">Subjects</p>
    <div class="list" :class="[showTags ? 'show' : '']" v-if="allTag.length != 0">        
      <ul style="margin: 3px;" v-for="(tag, tagIndex) in allTag" :key="tagIndex">
        <li class="tag_span" :style="{padding:'3px 10px', borderRadius: '50px'}" v-if="tag.subject_name">{{ tag.subject_name }}</li>
      </ul>
    </div>
  </div>
</div>
    `,
  data () {
    return {
      allTag: [],
      tagTooltipTag: '',
      showTags: false,
      rowIndex: 0
    }
  },
  beforeMount () {
    this.data = this.params.api.getDisplayedRowAtIndex(
      this.params.rowIndex
    ).data
    this.color = 'white'
    this.rowIndex = this.params.rowIndex
  },
  mounted () {
    console.log(this.params)
    this.allTag = this.params.value
    const allTagsArr = this.allTag.map((e) => {
      if (e.subject_name) {
        return e.subject_name
      }
    })
    this.tagTooltipTag = allTagsArr.join(', ')
    const colId = this.params.column.colId
    const row = document.querySelector('.ag-theme-material').querySelectorAll(`[row-index='${this.rowIndex}'] > [col-id]`)
    const element = [...row].find((el) => el.getAttribute('col-id') === colId)
    
    
    setTimeout(() => {
      document.body.appendChild(this.$refs.CustomTooltip)
      computePosition(element, this.$refs.CustomTooltip, {
        placement: 'top',
        middleware: [shift(), flip()]
      }).then((coordinates) => {
        Object.assign(this.$refs.CustomTooltip.style, {
          left: `${coordinates.x}px`,
          top: `${coordinates.y}px`
        })
      })
      this.$refs.CustomTooltip.style.visibility = 'visible'
    }, 0)
  }
})